import { render, staticRenderFns } from "./SelectIdea.vue?vue&type=template&id=656e5b3d&scoped=true"
import script from "./SelectIdea.vue?vue&type=script&lang=js"
export * from "./SelectIdea.vue?vue&type=script&lang=js"
import style0 from "./SelectIdea.vue?vue&type=style&index=0&id=656e5b3d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656e5b3d",
  null
  
)

export default component.exports